import { USER_LOCALE_STORAGE_KEY } from '~/shared/config/constants'
import { LocaleEnum } from '~/shared/config/enums'
import { storageGet, storageSet } from '~/shared/lib/storage'

export const useLocaleKeyStorage = () => {
  const localeStorageKeySet = (locale: LocaleEnum) => {
    storageSet<string>(USER_LOCALE_STORAGE_KEY, locale)
  }

  const localeStorageKeyGet = () => {
    return storageGet<LocaleEnum>(USER_LOCALE_STORAGE_KEY)
  }

  return {
    localeStorageKeyGet,
    localeStorageKeySet,
  }
}
